export enum RevelSyncMode {
  FULL = 'full',
  ADD_ONLY = 'add_only',
  PRICE_ONLY = 'price_only',
  ACTIVE_ONLY = 'active_only',
}
